import { formMessage } from 'shared/constants'
import * as yup from 'yup'

export const authSchema = yup
	.object({
		password: yup.string().required(formMessage.PASSWORD),
		phone: yup.string().required(formMessage.PHONE),
	})
	.required()
